import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SessionsService } from './sessions.service';

@Injectable()
export class SessionResolver implements Resolve<any> {
  constructor(private router: Router, private sessions: SessionsService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.sessions.getOne(route.params.id).catch(() => {
      this.router.navigate(['/error'], { skipLocationChange: true });
      return Observable.of(false);
    });
  }
}

@Injectable()
export class SessionsResolver implements Resolve<any> {
  constructor(private router: Router, private sessions: SessionsService) {}
  resolve(): Observable<any> {
    return this.sessions.getAll().catch(() => {
      this.router.navigate(['/error'], { skipLocationChange: true });
      return Observable.of(false);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/sessions.resolver.ts